"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNIVERSAL_SETTING_OWNER_TYPE = void 0;
exports.UNIVERSAL_SETTING_OWNER_TYPE = {
    SYSTEM: 'SYSTEM',
    CAMPAIGN: 'CAMPAIGN',
    LANDING: 'LANDING'
};
//# sourceMappingURL=universalSettingOwnerType.js.map